import { render } from "./LoadingAccessToken.vue?vue&type=template&id=b1c4e016"
import script from "./LoadingAccessToken.vue?vue&type=script&lang=js"
export * from "./LoadingAccessToken.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__